import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map, Observable } from 'rxjs';
import { HistoryItemResponse } from './models/history-item.response';
import { HistoryItem } from './models/history-item.model';
import { HistoryFactory } from './history.factory';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  private readonly http = inject(HttpClient);
  private readonly historyFactory = inject(HistoryFactory);

  getHistoryItemStats(recordId: string, type: string, parentId: string | null): Observable<HistoryItem> {
    const url = `${environment.apiUrl}/user-history/item`;
    const params = {
      recordId,
      type,
      parentRecordId: parentId,
    };

    return this.http.get<HistoryItemResponse>(url, { params }).pipe(
      map((item) => this.historyFactory.buildHistoryItem(item)),
    );
  }
}
